module.exports = __webpack_public_path__ + "static/media/deepLogo.fd703be5.png";